// useProspectStatus.js
import '@/assets/css/custom-tags.css';

export function useProspectStatus() {
   const showTag = (estado) => {
      const tags = {
         I: 'Iniciado',
         CPC: 'Contacto - Primer Contacto',
         CC: 'Contactado - Cotizando',
         EP: 'En proceso de cotización',
         C: 'Cotizado',
         PAR: 'Presentado - Aguardando respuesta',
         G: 'Ganado',
         A: 'Alta',
         NG: 'No Ganado',
         P: 'Pendiente',
         D: 'Derivado',
         CV: 'Coordinada la visita',
         PER: 'Peritado',
         SD: 'Siniestro diferido',
         SCE: 'Solicitud de cotización enviada',
         DES: 'Desestimado',
         PV: 'Plazo vencido',
         R: 'Rechazado',
         DS: 'Designado - Nota de designacion',
      };
      return tags[estado] || 'Desconocido';
   };

   const getSeverity = (estado) => {
      const severities = {
         I: 'custom-initial',
         CPC: 'custom-cpc',
         CC: 'custom-cc',
         EP: 'custom-ep',
         C: 'custom-cotizado',
         PAR: 'custom-par',
         G: 'custom-ganado',
         A: 'custom-ganado',
         NG: 'custom-ng',
         P: 'custom-pendiente',
         D: 'custom-derivado',
         CV: 'custom-cv',
         PER: 'custom-per',
         SD: 'custom-sd',
         SCE: 'custom-sce',
         DES: 'custom-des',
         PV: 'custom-ng',
         R: 'custom-ng',
         DS: 'custom-ds',
         PN: 'custom-pn',
      };
      return severities[estado] || 'custom-unknown';
   };

   const getProgress = (estado) => {
      const progress = {
         CPC: 20,
         CC: 30,
         I: 10,
         EP: 50,
         C: 70,
         PAR: 90,
         PN: 95,
         G: 100,
         NG: 100,
         DES: 100,
         PV: 100,
         R: 100,
      };
      return progress[estado] || 0;
   };

   const getSeverityByDays = (days) => {
      if (days > 5) return 'info';
      if (days > 1) return 'warning';
      return 'danger';
   };

   return { showTag, getSeverity, getProgress, getSeverityByDays };
}
